import { useState } from "react";
import axios from 'axios'
import useSnackbar from '@/hooks/useSnackbar'
import { USE_MOCK, API_BASE } from "@/utils/constants";
import { useNavigate } from "react-router-dom";
import { httpErrorHandler } from "@/utils/httpErrorHandler";

import "../assets/styles/SignUpPage.css";

import logoIcon from "../assets/images/login-logo.png";
import userIcon from "../assets/images/user.png";
import emailIcon from "../assets/images/email.png";
import lockIcon from "../assets/images/lock.png";
import eyeOpen from "../assets/images/eyeopen.png";
import eyeClose from "../assets/images/eyeclose.png";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).+$/;


const isValidPassword = (password) => {
  return passwordRegex.test(password);
}

export default function SignUpPage({ onRegister }) {
	const [form, setForm] = useState({
		name: "",
		last_name: "",
		email: "",
		password: "",
		confirm: "",
	});
	const [showPass, setShowPass] = useState(false);
	const [showConfirm, setShowConfirm] = useState(false);
	const [remember, setRemember] = useState(false);
	const [loading, setLoading] = useState(false);
	const { showSnackbar } = useSnackbar();
	const navigate = useNavigate();

	const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

	const handleSubmit = async (e) => {
		e.preventDefault();

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(form.email?.trim())) {
			showSnackbar('فرمت ایمیل نامعتبر است', { type: 'error' });
			return;
		}

		if (!isValidPassword(form.password)){
			showSnackbar('رمز عبور باید شامل حداقل یک حرف بزرگ، یک حرف کوچک، یک عدد و یک کاراکتر ویژه باشد.', { type: "error" });
			return;
		}
		else if (form.password.length < 8) {
			showSnackbar('رمز عبور باید حداقل 8 کاراکتر باشد', { type: "error" });
			return;
		}
		else if (form.password !== form.confirm) {
			showSnackbar('رمز عبور و تکرار آن یکسان نیست', { type: "error" });
			return;
		}

		if (remember) localStorage.setItem("remembered_email", form.email.trim());
		else localStorage.removeItem("remembered_email");

		if (USE_MOCK) {
			localStorage.setItem("token", "mock-token");
			onRegister?.({ email: form.email, name: form.name });
			return;
		}

		setLoading(true);

		axios.post(`${API_BASE}/auth/signup`,
			{
				email: form.email.trim(),
				password: form.password,
				first_name: form.name.trim(),
				last_name: form.last_name.trim(),
				confirm_password: form.confirm.trim()
			}
		).then(res => {
			const token = res.data?.token;
			const user_id = res.data?.user_id;

			if (token) localStorage.setItem('token', token)
			if (user_id) localStorage.setItem('user_id', user_id)

			onRegister?.({ email: form.email.trim() });

			navigate('/');

		}).catch(err => {
			httpErrorHandler({
				err: err,
				errorKeys: ['email', 'password', 'first_name', 'last_name'],
				setFieldErrors: {},
				setSnackbar: (s) => showSnackbar(s?.message || '', { type: s?.type || 'error' }),
				navigate: navigate
			});

		}).finally(() => {
			setLoading(false);
		});


		//   const data = await response.json();
		//   const token = data?.token || data?.access_token || data?.data?.token;

		//   if (!token) throw new Error("توکن از سرور دریافت نشد");

		//   localStorage.setItem("token", token);
		//   onRegister?.({ email: form.email, name: form.name });
		// }
	};

	return (
		<div className="register-page">
			<div className="register-card">
				<div className="register-logo">
					<img src={logoIcon} alt="لوگو" />
				</div>

				<form className="register-form" onSubmit={handleSubmit}>
					{/* نام */}
					<div className="field">
						<label className="field-label">
							<img src={userIcon} alt="user" />
							<span>نام</span>
						</label>
						<div className="input-wrap">
							<input
								type="text"
								name="name"
								placeholder="نام خود را وارد کنید"
								value={form.name}
								onChange={handleChange}
								required
							/>
						</div>
					</div>

					{/* نام خانوادگی */}
					<div className="field">
						<label className="field-label">
							<img src={userIcon} alt="user" />
							<span>نام خانوادگی</span>
						</label>
						<div className="input-wrap">
							<input
								type="text"
								name="last_name"
								placeholder="نام خانوادگی خود را وارد کنید"
								value={form.last_name}
								onChange={handleChange}
								required
							/>
						</div>
					</div>

					{/* ایمیل */}
					<div className="field">
						<label className="field-label">
							<img src={emailIcon} alt="email" />
							<span>ایمیل</span>
						</label>
						<div className="input-wrap">
							<input
								type="email"
								name="email"
								placeholder="ایمیل خود را وارد کنید"
								value={form.email}
								onChange={handleChange}
								required
							/>
						</div>
					</div>

					{/* رمز عبور */}
					<div className="field">
						<label className="field-label">
							<img src={lockIcon} alt="lock" />
							<span>رمز عبور</span>
						</label>
						<div className="input-wrap has-eye">
							<input
								type={showPass ? "text" : "password"}
								name="password"
								placeholder="رمز عبور خود را وارد کنید"
								value={form.password}
								onChange={handleChange}
								required
							/>
							<button
								type="button"
								className="eye-btn"
								onClick={() => setShowPass((v) => !v)}
							>
								<img src={showPass ? eyeOpen : eyeClose} alt="چشم" />
							</button>
						</div>
					</div>

					{/* تکرار رمز عبور */}
					<div className="field">
						<label className="field-label">
							<img src={lockIcon} alt="lock" />
							<span>تکرار رمز عبور</span>
						</label>
						<div className="input-wrap has-eye">
							<input
								type={showConfirm ? "text" : "password"}
								name="confirm"
								placeholder="رمز عبور خود را دوباره وارد کنید"
								value={form.confirm}
								onChange={handleChange}
								required
							/>
							<button
								type="button"
								className="eye-btn"
								onClick={() => setShowConfirm((v) => !v)}
							>
								<img src={showConfirm ? eyeOpen : eyeClose} alt="چشم" />
							</button>
						</div>
					</div>

					<label className="remember-inline">
						<input
							type="checkbox"
							checked={remember}
							onChange={(e) => setRemember(e.target.checked)}
						/>
						<span>مرا به خاطر بسپار</span>
					</label>

					<button type="submit" className="btn primary" disabled={loading}>
						{loading ? "در حال ثبت‌نام..." : "ثبت نام در زیست‌یار"}
					</button>

					<p className="login-link">
						عضو سایت هستید؟{" "}
						<button
							type="button"
							className="link-btn"
							onClick={() => navigate("/login")}
						>
							ورود
						</button>
					</p>
				</form>
			</div>
			{/* Global snackbar handled by SnackbarProvider */}
		</div>
	);
}
